export const ItemListingTypeEnum = {
  Multiple: 46,
  Single: 47,
  Custom: 141
} as const;

export type ItemListingType = typeof ItemListingTypeEnum[keyof typeof ItemListingTypeEnum];

export interface ItemModel {
  id: number;
  name: string;
  itemId: string;
  communityId: number;
  communityName: string;
  typeId: number;
  typeName: string;
  statusId: number;
  statusName: string;
  locationName: string;
  address: string;
  description: string;
  originalDescription: string;
  quantity: number;
  remainingQuantity: number;
  price: number | null;
  participationMethod: number;
  customItemFormLink?: string;
  blobUrls: string;
  itemLatitude: number | null;
  itemLongitude: number | null;
  documentBlobUrls: string;
  isPosted: boolean;
  featureImage: string;
  dedicatedTo: string;
  donatedBy?: string;
  plaqueId: number;
  plaqueName: string;
  communityProfileBlob?: string;
  campaignProfileBlob?: string;
  campaignId?: number;
  paymentLink?: string;
  fallbackUrl?: string;
  airtableId?: string;
  isDonorActivityAssociated?: boolean;
  itemListingType?: ItemListingType;
  customMinPrice?: number;
  customMaxPrice?: number;
  campaignName?: string;
  campaignIsPublic?:boolean;
  hasEventTimeEntered?: boolean;
  itemEventEndTime?:string;
  itemEventStartTime?:string;
  itemDateEventType?: number;
  eventTimeZone?: number;
  campaignTypeId?: number;
  formTypeId: number;
  formMasterId?: number;
  isAcceptPaymentOnline: boolean;
  formSchema?:string;
  formTitle?:string;
  formDescription?:string;
  hasShifts: boolean;
  shifts?: VolunteerShiftDto[];
  sortOrder?: number | null;
  isUnlimitedParticipation?: boolean;
  isInteractiveTourCampaign?:boolean;
  accessType?:number;
  itemCustomMessage?:string;
  isFreeTicket?: boolean | null;
  requireApplicantApproval?: boolean;
  hasDiscountGroups?: boolean;
  discountGroups?: DiscountGroupDto[];
  hasFreeTicketOption?: boolean;
  discountGroupMinPrice?: number | null;
  discountGroupMaxPrice?: number | null;
  isMaxTicketCapacityEnabled?: boolean;
  maxTicketCapacity?: number | null;
  remainingMaxCapacity?: number | null;
  donorRecognitionBlobUrl?: string;
  /**
   * Public website of the sponsor, business or tour location. Requested from
   * the backend (see docs/specs/001-campaign-overview/spec.md, API
   * Consumption); the UI hides the row while it is absent.
   */
  websiteUrl?: string | null;
  /**
   * Display category of a tour location, e.g. "Food + Beverage". Requested
   * from the backend alongside `websiteUrl`; hidden while absent.
   */
  categoryName?: string | null;
}

export interface IItemCreateDto {
  name: string; // required
  description?: string;
  originalDescription?: string; 
  typeId: number; // required
  itemLatitude?: number;
  itemLongitude?: number;
  address?: string;
  price?: number;
  quantity: number;
  locationName?: string;
  statusId: number; // required
  isPosted: boolean;
  participationMethod?: number;
  customItemFormLink?: string;
  communityId: number; // required
  communityName: string; // required
  campaignId?: number | null; // required
  blobUrls?: string;
  id: number;
  documentBlobUrls?: string;
  dedicatedTo?: string;
  donatedBy?: string;
  plaqueId?: string;
  itemListingType?: ItemListingType;
  customMinPrice?: number;
  customMaxPrice?: number;
  ItemDateEventType?: number;
  ItemEventStartTime?: string;
  ItemEventEndTime?:string;
  hasEventTimeEntered?: boolean;
  isAcceptPaymentOnline: boolean;
  formTypeId: number;
  formMasterId?: number | null; 
  itemEventTimeZone?: number | null;
  shifts?: VolunteerShiftDto[];
  hasShifts?: boolean;
  isUnlimitedParticipation?: boolean;
  sortOrder?: number | null;
  itemCustomMessage?:string;
  isFreeTicket?: boolean | null;
  hasDiscountGroups?: boolean;
  discountGroups?: DiscountGroupDto[];
}


export interface AddUpdateItemSession {
  campaignId?: number;
  communityId: number;
  existingItemId?: number;
  isFromCommunityStories?: boolean;
  isStoryteller?: boolean;
  listingTypeId?: ItemListingType;
  isVolunteerEvent?: boolean;
}

export interface ItemPatchDto {
  latitude: number;
  longitude: number;
}
export interface RecordPaymentDTO {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  organizationBusinessName?: string;
  price: number;
  paymentMethod: number;
  details?: string;
  documentBlobUrl?: string;
  photoGalleryBlobUrl?: string;
  isGenerateTaxReceipt: boolean;
  isGenerateDonationCard: boolean;
  isEmailTicketsToPurchaser: boolean;
  numberOfTickets?: number;
  paymentDate?: string;
}

export interface RecordPaymentTwoPartDTO {
  amount: number;
  paymentMethod: number;
  isGenerateTaxReceipt: boolean;
  paymentDate: string;
}

export interface IFormOverviewModel{
  title?: string;
  description?:string;
  schema?:string;
}

export interface VolunteerShiftDto {
  id?: number;
  title: string;
  eventStartDateTime: string;
  eventEndDateTime: string;
  quantity: number;
  donationCompletedCount?: number;
  itemId?: number;
  startTimeAPM?: string;
  endTimeAPM?: string;
}

export interface DiscountGroupDto {
  id?: number;
  discountGroupId?: string;
  title: string;
  price?: number | null;
  isFreeTicket: boolean;
  sortOrder?: number | null;
}